import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

import { MainDrawer } from '../components';
import { useDrawer } from '../hooks';


export const LayoutBase: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isDrawerOpen } = useDrawer();

  return (
    <Box display='flex' justifyContent='center'>
      <MainDrawer />
      <Box
        component="main"
        width='100%'
        sx={{
          transition: 'all .1s',
          padding: !isDrawerOpen ? '0 0 0 30px' : '0 0 0 250px',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};


